import { parseJwt } from '../services/jwtParser';
import { clear } from './dataLoadedActionsCreator';

export const login = (token) => ({ type: 'LOGGED_IN', payload: parseJwt(token) });
export const logout = () => (dispatch) => {
  dispatch({ type:'RESET_SUB_MENU' })
  dispatch({ type: 'LOGGED_OUT' });
  dispatch(clear('userInfo'));
  dispatch(clear('salesman'));
  dispatch(clear('cases'));
  dispatch(clear('referrals'));
  dispatch(clear('revenues'));
  dispatch(clear('agents'));
  dispatch(clear('customers'));
  dispatch(clear('articles'));
}
